import { mediaTranscriptApi } from "@circle-react/api/mediaTranscriptApi";
import type { MediaTranscript } from "@circle-react/types/MediaTranscript";
import { useQuery } from "react-query";

import type { ApiError } from "@/react/config/CustomErrors";

import { useParsedWebVTTFile } from "./useParsedWebVTTFile";

export const useMediaTranscript = (mediaTranscriptId: number | null) => {
  const {
    data: mediaTranscript,
    isInitialLoading: isLoading,
    refetch,
  } = useQuery<MediaTranscript, ApiError>({
    queryKey: ["mediaTranscript", mediaTranscriptId],
    queryFn: () => mediaTranscriptApi.show(mediaTranscriptId ?? -1),
    enabled: !!mediaTranscriptId,
  });
  const { webvtt, parsedWebvtt } = useParsedWebVTTFile(mediaTranscript) || {};

  return {
    mediaTranscript,
    isLoading,
    webvtt,
    parsedWebvtt,
    refetch,
  };
};
